export const AttestationStatus = {
  AS_NOR: 0, // 普通
  AS_OCC: 1, // 职业棋手
  AS_CHA: 2, // 世界冠军（金冠）
  AS_AMA: 3, // 业余强豪
  AS_CHA_NATIONAL: 4, // 全国冠军（银冠）
  AS_CHA_AMATEUR: 5, // 业余冠军，也称业余天王（铁冠）
};

export const MemberType = {
    UMT_NONE: 0,        //非会员
    UMT_GOLD: 1,        //金卡会员
    UMT_WHITE_GOLD: 2,        //白金会员
    UMT_STUDY_MATCH_YEAR: 4,   //学习比赛年卡
    UMT_MATCH_YEAR: 5,        //比赛年卡
    UMT_MATCH_ONCE: 6,        //单次比赛卡
};

/**
 * 根据用户的职业和性别获取对应的认证图标路径
 * @param {import('../../common/models/User').default} user
 * @returns {string} 图标路径或空字符串
 */
export function getAttestationIcon(user) {
  const occupation = user.occupation();
  const gender = user.gender();
  const ai = user.ai();
  const ye6 = user.ye6();

  switch (occupation) {
    case AttestationStatus.AS_OCC:
      if (ai === 1) {
        return '/assets/2doge.png';
      }
      else {
        return gender === 0 ? '/assets/p1.png' : '/assets/p2.png';
      }
    case AttestationStatus.AS_CHA:
      if (ai === 1) {
        return '/assets/1doge.png';
      }
      else {
        return gender === 0 ? '/assets/huangguan2.png' : '/assets/huangguan1.png';
      }
    case AttestationStatus.AS_CHA_NATIONAL:
      return '/assets/huangguan4.png';
    case AttestationStatus.AS_CHA_AMATEUR:
      return '/assets/huangguan3.png';
    case AttestationStatus.AS_AMA:
      return '/assets/a.png';
    case AttestationStatus.AS_NOR:
      if (ai === 1) {
        return '/assets/3doge.png';
      }
      else if (ye6 === 1) {
        return '/assets/6.png';
      }
      else {
        return '';
      }
    default:
      return '';
  }
}

/**
 * 根据用户的职业获取对应的认证名称
 * @param {import('../../common/models/User').default} user
 * @returns {string} 认证名称
 */
export function getAttestationName(user) {
  const occupation = user.occupation();
  const ye6 = user.ye6();
  const ai = user.ai();
  if (ai === 1) {
    return 'AI';
  }

  switch (occupation) {
    case AttestationStatus.AS_NOR:
      if (ye6 === 1) {
        return '业6';
      }
      else {
        return '普通棋手';
      }
    case AttestationStatus.AS_OCC:
      return '职业棋手';
    case AttestationStatus.AS_CHA:
      return '世界冠军';
    case AttestationStatus.AS_AMA:
      return '业余强豪';
    case AttestationStatus.AS_CHA_NATIONAL:
      return '全国冠军';
    case AttestationStatus.AS_CHA_AMATEUR:
      return '业余冠军';
    default:
      return '';
  }
}

/**
 * 根据用户的会员类型和到期时间获取会员图标
 * @param {import('../../common/models/User').default} user
 * @returns {string} 图标路径或空字符串
 */
export function getMemberIcon(user) {
  const memberType = user.member_type();
  const memberEndDate = user.member_end_date(); // 假设为 Unix 时间戳（秒）
  const currentTime = Math.floor(Date.now() / 1000);

  // 如果设置了过期时间且当前时间已超过过期时间，则视为已过期
  if (memberEndDate > 0 && currentTime > memberEndDate) {
    return '';
  }

  switch (memberType) {
    case MemberType.UMT_GOLD:
      return '/assets/vip_jin.png';
    case MemberType.UMT_WHITE_GOLD:
      return '/assets/vip_baijin.png';
    default:
      return '';
  }
}

/**
 * 根据用户的会员类型和到期时间获取会员名称
 * @param {import('../../common/models/User').default} user
 * @returns {string} 会员名称或空字符串
 */
export function getMemberName(user) {
  const memberType = user.member_type();
  const memberEndDate = user.member_end_date();
  const currentTime = Math.floor(Date.now() / 1000);

  // 如果设置了过期时间且当前时间已超过过期时间，则视为已过期
  if (memberEndDate > 0 && currentTime > memberEndDate) {
    return '';
  }

  switch (memberType) {
    case MemberType.UMT_GOLD:
      return '金卡会员';
    case MemberType.UMT_WHITE_GOLD:
      return '白金会员';
    default:
      return '';
  }
}




